import I18n from "lib/i18n/i18n";

let menuStrings = I18n.getString('menu');

export const tabs = {
    baseItems: [
        {
            "title": I18n.getString('header::menu::titles::sellYourItem'),
            "link": "/",
            "mobile": 1,
            "desktop": false
        },
        {
            "title": I18n.getString('header::menu::titles::howItWorks'),
            "rootLink": "/about/how-it-works",
            "mobile": 2
        },
        {
            "title": I18n.getString('header::menu::titles::recentAuctions'),
            "rootLink": "/about/recent-deals/rings",
            "mobile": false
        },
        {
            "title": I18n.getString('header::menu::titles::reviews'),
            "rootLink": "/about/reviews",
            "mobile": 3
        },
    ],
    signInItems: {
        loggedIn: {
            "title": I18n.getString('header::menu::titles::hi'),
            "link": "/items",
            "mobile": false,
            "subItems": [
                {
                    "title": I18n.getString('header::menu::titles::myAccount'),
                    "link": "/items",
                    "mobile": 10
                }]
        },
        signIn: {
            "title": I18n.getString('header::menu::titles::logIn'),
            "link": "/signin",
            "mobile": 10
        }
    }
}

// export const menuTabs = tabs.map((tab,idx) => {
//     return {...tab, title:Object.keys(menuStrings.titles).map((x) => menuStrings.titles[x])[idx]}
// });
